// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tray {
    display: flex;
    flex-direction: column;
    background-color: var(--tiles);
    border: none;
    border-radius: 2rem;
    color: var(--text);
    width: 75%;
    min-width: 400px;
    font-family: 'Poppins', sans-serif;
    padding: 2%;
    overflow-y: auto;
    gap:0.5rem;
}

.todo {
    font-family: 'Poppins', sans-serif;
    font-size: 1.2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: var(--todo);
    border-radius: 1rem;
    height: 1rem;
    align-items: center;
    padding: 0.5rem;
    transition: box-shadow 0.5s;
}
.todo:hover {
    box-shadow: 0 2px 6px 0 var(--check), 0 4px 10px 0 var(--check);
}
.todo-done {
    color: rgba(128, 128, 128, 0.468);
    text-decoration: line-through var(--primary);
}


.check-box {
  height: 1.2rem;
  width: 1.2rem;
  background-color: var(--check);
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.5s;
}
.check-box:hover {
    background-color: var(--primary);
}
.completed {
    background-color: var(--primary);
}

.todo-description {
    color: gray;
    font-size: 0.8rem;
    overflow-y: auto;
    overflow-x: visible;
}

.left-half,.right-half {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    align-items: center;
    overflow-y: auto;
}

.due-date {
    color:var(--primary);
}

.project-name {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.493);
}

.bin {
    color: var(--text);
    transition: color 0.5s;
}
.bin:hover {
    color: var(--secondary);
}


.todo-star {
    color:gold;
}

.priority {
    font-size: 1rem;
}

.priority.low {
    color: green;
}

.priority.medium {
    color: yellow;
}

.priority.high {
    color: red;
}`, "",{"version":3,"sources":["webpack://./src/styles/tray.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,+DAA+D;AACnE;AACA;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;;AAGA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd","sourcesContent":["@import url(./themes.css);\r\n\r\n.tray {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: var(--tiles);\r\n    border: none;\r\n    border-radius: 2rem;\r\n    color: var(--text);\r\n    width: 75%;\r\n    min-width: 400px;\r\n    font-family: 'Poppins', sans-serif;\r\n    padding: 2%;\r\n    overflow-y: auto;\r\n    gap:0.5rem;\r\n}\r\n\r\n.todo {\r\n    font-family: 'Poppins', sans-serif;\r\n    font-size: 1.2rem;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    background-color: var(--todo);\r\n    border-radius: 1rem;\r\n    height: 1rem;\r\n    align-items: center;\r\n    padding: 0.5rem;\r\n    transition: box-shadow 0.5s;\r\n}\r\n.todo:hover {\r\n    box-shadow: 0 2px 6px 0 var(--check), 0 4px 10px 0 var(--check);\r\n}\r\n.todo-done {\r\n    color: rgba(128, 128, 128, 0.468);\r\n    text-decoration: line-through var(--primary);\r\n}\r\n\r\n\r\n.check-box {\r\n  height: 1.2rem;\r\n  width: 1.2rem;\r\n  background-color: var(--check);\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  transition: background 0.5s;\r\n}\r\n.check-box:hover {\r\n    background-color: var(--primary);\r\n}\r\n.completed {\r\n    background-color: var(--primary);\r\n}\r\n\r\n.todo-description {\r\n    color: gray;\r\n    font-size: 0.8rem;\r\n    overflow-y: auto;\r\n    overflow-x: visible;\r\n}\r\n\r\n.left-half,.right-half {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 1rem;\r\n    align-items: center;\r\n    overflow-y: auto;\r\n}\r\n\r\n.due-date {\r\n    color:var(--primary);\r\n}\r\n\r\n.project-name {\r\n    font-size: 0.8rem;\r\n    color: rgba(255, 255, 255, 0.493);\r\n}\r\n\r\n.bin {\r\n    color: var(--text);\r\n    transition: color 0.5s;\r\n}\r\n.bin:hover {\r\n    color: var(--secondary);\r\n}\r\n\r\n\r\n.todo-star {\r\n    color:gold;\r\n}\r\n\r\n.priority {\r\n    font-size: 1rem;\r\n}\r\n\r\n.priority.low {\r\n    color: green;\r\n}\r\n\r\n.priority.medium {\r\n    color: yellow;\r\n}\r\n\r\n.priority.high {\r\n    color: red;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
